import { render, staticRenderFns } from "./collapsed_assignee.vue?vue&type=template&id=a2843fc8"
import script from "./collapsed_assignee.vue?vue&type=script&lang=js"
export * from "./collapsed_assignee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports